var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.898-78.668q-32.513 0-56.205-23.692-23.691-23.692-23.691-56.205v-642.87q0-32.513 23.691-56.205 23.692-23.692 56.205-23.692h299.385q16.384 0 31.16 6.469 14.776 6.468 25.814 17.377L776.152-678.59q10.852 11.68 17.349 26.182 6.497 14.503 6.497 31.458v462.385q0 32.513-23.691 56.205-23.692 23.692-56.205 23.692H239.898ZM539.027-662.13v-151.614H239.898q-4.615 0-8.462 3.847-3.846 3.846-3.846 8.462v642.87q0 4.616 3.846 8.462 3.847 3.847 8.462 3.847h480.204q4.615 0 8.462-3.847 3.846-3.846 3.846-8.462v-463.283H579.309q-16.807 0-28.545-11.737-11.737-11.737-11.737-28.545ZM227.59-813.744v191.896-191.896V-146.256-813.744Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDefault);
export default __webpack_public_path__ + "static/media/White-Default.d733f1d573337e70b4ec9fd35c2e99ce.svg";
export { ForwardRef as ReactComponent };